import React from 'react';
import { motion } from 'framer-motion';
import { FiAward, FiUsers, FiActivity, FiLayers } from 'react-icons/fi';

const About = () => {
  return (
    <section id="about" className="py-24 bg-slate-950">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="grid lg:grid-cols-2 gap-16 items-center"
        >
          <div>
            <h2 className="font-display text-3xl md:text-4xl font-bold mb-6">
              Bridging Technical Depth with <span className="text-gradient">User Success</span>
            </h2>
            <div className="space-y-6 text-slate-400 leading-relaxed text-sm md:text-base">
              <p>
                As a <strong className="text-white">Full Stack Developer</strong> proficient in <strong className="text-white">Reactjs, Node.js, MongoDB, RabbitMQ</strong>, and <strong className="text-white">AI Technologies</strong>, I specialize in building scalable web applications that solve real-world problems.
              </p>
              <p>
                My unique background includes leading backend development at Questera AI for products with 20K+ MAU, combined with years of prior experience as an SME and Technical Support specialist. This duality ensures I write code that is not only highly scalable and event-driven, but also deeply empathetic to the end-user's needs.
              </p>
              <p>
                From successfully implementing async processing workflows to delivering 15+ end-to-end projects, I don't just build features; I take ownership to deliver solutions that drive real business impact and scale gracefully under heavy traffic.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 md:gap-6">
            <StatCard 
              icon={FiAward} 
              value="6+" 
              label="Years of IT Experience" 
              sub="Full Stack & Support" 
            />
            <StatCard 
              icon={FiLayers} 
              value="15+" 
              label="Projects End-to-End" 
              sub="SaaS & AI Applications" 
            />
            <StatCard 
              icon={FiUsers} 
              value="20K+" 
              label="Monthly Active Users" 
              sub="Scale performance" 
            />
            <StatCard 
              icon={FiActivity} 
              value="200K+" 
              label="API Requests Monthly" 
              sub="High-throughput systems" 
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

const StatCard = ({ icon: Icon, value, label, sub }) => (
  <div className="glass-card p-5 md:p-6 rounded-2xl hover:bg-slate-800/50 transition-all duration-300 border border-slate-800/50 hover:border-indigo-500/30">
    <Icon className="text-indigo-500 text-2xl md:text-3xl mb-3" />
    <div className="font-display text-2xl md:text-3xl font-bold text-white mb-1">{value}</div>
    <div className="font-medium text-white text-xs md:text-sm leading-tight mb-1">{label}</div>
    <div className="text-[10px] md:text-xs text-slate-500">{sub}</div>
  </div>
);

export default About;